var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4135_27087)",
    filter: "url(#filter0_d_4135_27087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0704 11.4418L9.58203 9.76733V22.1396C9.58203 22.7046 10.0401 23.1627 10.6051 23.1627H26.9776C27.5426 23.1627 28.0006 22.7046 28.0006 22.1396V17.5813L19.0704 11.4418Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0704 0.837158H10.6051C10.0401 0.837158 9.58203 1.2952 9.58203 1.86023V6.41855L19.0704 11.9999L24.0937 13.6744L28.0006 11.9999V6.41855L19.0704 0.837158Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 6.41846H19.0704V11.9999H9.58203V6.41846Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.3729 5.30225H9.58203V19.2557H16.3729C16.9372 19.2539 17.3942 18.7969 17.396 18.2327V6.32531C17.3942 5.76105 16.9372 5.30408 16.3729 5.30225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8148 5.86035H9.58203V19.8138H15.8148C16.379 19.812 16.836 19.355 16.8378 18.7908V6.88342C16.836 6.31916 16.379 5.86219 15.8148 5.86035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8148 5.86035H9.58203V18.6976H15.8148C16.379 18.6957 16.836 18.2388 16.8378 17.6745V6.88342C16.836 6.31916 16.379 5.86219 15.8148 5.86035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2566 5.86035H9.58203V18.6976H15.2566C15.8209 18.6957 16.2779 18.2388 16.2797 17.6745V6.88342C16.2779 6.31916 15.8209 5.86219 15.2566 5.86035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02307 5.86047H15.256C15.821 5.86047 16.2791 6.31851 16.2791 6.88354V17.1165C16.2791 17.6815 15.821 18.1395 15.256 18.1395H5.02307C4.45804 18.1395 4 17.6815 4 17.1165V6.88354C4 6.31851 4.45804 5.86047 5.02307 5.86047Z",
    fill: "url(#paint0_linear_4135_27087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 15.3254L9.32015 11.9905L7.34825 8.67407H8.93448L10.0106 10.795C10.1099 10.9965 10.178 11.1461 10.2149 11.2449H10.2288C10.2995 11.0841 10.3739 10.928 10.4521 10.7766L11.6024 8.67519H13.0586L11.0364 11.9721L13.1099 15.3254H11.5605L10.3176 12.9974C10.259 12.8984 10.2093 12.7943 10.1691 12.6865H10.1507C10.1143 12.7921 10.066 12.8933 10.0067 12.9879L8.72686 15.3254H7.16797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9775 0.837158H19.0703V6.41855H28.0005V1.86023C28.0005 1.2952 27.5425 0.837158 26.9775 0.837158Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0703 12H28.0005V17.5814H19.0703V12Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4135_27087",
    x: 0,
    y: 0.837158,
    width: 32,
    height: 30.3256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4135_27087"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4135_27087",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4135_27087",
    x1: 6.13312,
    y1: 5.06107,
    x2: 14.1459,
    y2: 18.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4135_27087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.3256,
    fill: "white",
    transform: "translate(4 0.837158)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon_excel.520ca79b1a86083f31e4c296b35f4bfa.svg";
export { ForwardRef as ReactComponent };